import { render, staticRenderFns } from "./Banners.vue?vue&type=template&id=39c559b0&scoped=true"
import script from "./Banners.vue?vue&type=script&lang=js"
export * from "./Banners.vue?vue&type=script&lang=js"
import style0 from "./Banners.vue?vue&type=style&index=0&id=39c559b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c559b0",
  null
  
)

export default component.exports